export const SCOPE = 'module:appViewerSessions';

export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const UPDATE_QUERY = `${SCOPE}/UPDATE_QUERY`;
export const FETCHING = `${SCOPE}/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}/FETCHING_SUCCESS`;
export const FETCHING_FAIL = `${SCOPE}/FETCHING_FAIL`;
